.TableWrapper {
  :global(.search.control.has-icons-left) {
    width: auto;
  }
}
